/* ============================================================================
   FOLLIVA INSTRUMENT — core JS foundation
   Helpers, event bus, fetch, Section Rendering API, money, base element.
   Extends window.FL (routes/settings/moneyFormat set in theme.liquid).
   ============================================================================ */
(function () {
  "use strict";
  var FL = (window.FL = window.FL || {});

  /* ---- DOM helpers ---- */
  FL.$ = function (sel, root) { return (root || document).querySelector(sel); };
  FL.$$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  FL.on = function (el, ev, fn, opts) { el.addEventListener(ev, fn, opts); return function () { el.removeEventListener(ev, fn, opts); }; };

  /* ---- Event bus (document-level CustomEvents) ---- */
  FL.emit = function (name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail || {}, bubbles: true })); };
  FL.listen = function (name, fn) { document.addEventListener(name, fn); return function () { document.removeEventListener(name, fn); }; };

  /* ---- Utils ---- */
  FL.debounce = function (fn, wait) {
    var t; return function () { var ctx = this, args = arguments; clearTimeout(t); t = setTimeout(function () { fn.apply(ctx, args); }, wait); };
  };
  FL.clamp = function (n, min, max) { return Math.max(min, Math.min(max, n)); };

  /* ---- Money ---- */
  FL.money = function (cents) {
    var fmt = FL.moneyFormat || "${{amount}}";
    var value = (cents / 100);
    function fmtNum(dp, ts, ds) {
      dp = dp == null ? 2 : dp; ts = ts == null ? "," : ts; ds = ds == null ? "." : ds;
      var parts = value.toFixed(dp).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts[1] ? parts.join(ds) : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case "amount": return fmtNum(2, ",", ".");
        case "amount_no_decimals": return fmtNum(0, ",", ".");
        case "amount_with_comma_separator": return fmtNum(2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return fmtNum(0, ".", ",");
        case "amount_with_space_separator": return fmtNum(2, " ", ",");
        case "amount_with_apostrophe_separator": return fmtNum(2, "'", ".");
        default: return fmtNum(2, ",", ".");
      }
    });
  };

  /* ---- Fetch JSON with Shopify headers ---- */
  FL.fetchJSON = function (url, opts) {
    opts = opts || {};
    var headers = Object.assign({ "Content-Type": "application/json", "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }, opts.headers || {});
    return fetch(url, {
      method: opts.method || "GET",
      headers: headers,
      body: opts.body ? (typeof opts.body === "string" ? opts.body : JSON.stringify(opts.body)) : undefined,
      credentials: "same-origin"
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var e = new Error(data.description || data.message || "Request failed"); e.status = r.status; e.data = data; throw e; }
        return data;
      });
    });
  };

  /* ---- Section Rendering API ---- */
  FL.cartSectionIds = function () {
    return FL.$$("[data-fl-cart-section]").map(function (el) { return el.getAttribute("data-fl-cart-section"); })
      .filter(function (v, i, a) { return v && a.indexOf(v) === i; });
  };
  FL.renderSections = function (ids, url) {
    if (!ids || !ids.length) return Promise.resolve({});
    var u = (url || FL.routes.root) + "?sections=" + encodeURIComponent(ids.join(","));
    return fetch(u, { credentials: "same-origin" }).then(function (r) { return r.json(); });
  };

  /* ---- Focus trap ---- */
  FL.trapFocus = function (container, opts) {
    opts = opts || {};
    var sel = 'a[href],button:not([disabled]),textarea,input,select,summary,[tabindex]:not([tabindex="-1"])';
    function focusables() { return FL.$$(sel, container).filter(function (el) { return el.offsetParent !== null; }); }
    function onKey(e) {
      if (e.key === "Escape" && opts.onEscape) { opts.onEscape(); return; }
      if (e.key !== "Tab") return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    document.addEventListener("keydown", onKey);
    var f = focusables(); if (f.length && opts.autofocus !== false) f[0].focus();
    return function () { document.removeEventListener("keydown", onKey); };
  };

  FL.lockScroll = function (on) {
    document.documentElement.style.overflow = on ? "hidden" : "";
    document.body.style.overflow = on ? "hidden" : "";
  };

  /* ---- Base custom element: idempotent connect + auto-cleanup ---- */
  FL.Element = class extends HTMLElement {
    connectedCallback() { if (this._flReady) return; this._flReady = true; this._cleanups = []; try { this.init(); } catch (e) { console.error("[FL]", this.tagName, e); } }
    disconnectedCallback() { (this._cleanups || []).forEach(function (fn) { try { fn(); } catch (e) {} }); this._cleanups = []; this._flReady = false; }
    track(fn) { if (fn) this._cleanups.push(fn); return fn; }
    init() {}
  };

  /* ---- Editor mode flag ---- */
  if (window.Shopify && window.Shopify.designMode) { document.documentElement.classList.add("fl-editor"); }

  FL.ready = function (fn) { if (document.readyState !== "loading") fn(); else document.addEventListener("DOMContentLoaded", fn); };
})();
